var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2992 23.0089C10.9826 23.0089 8.90318 21.5729 8.06023 19.3914L6.96843 16.569C6.85644 16.3126 6.73747 16.1467 6.61149 16.0696C6.48474 15.9925 6.27943 15.954 5.9956 15.954H5.50958L5.22187 18.34C4.89992 21.0051 2.66266 23.0089 0.0078125 23.0089L2.23729 4.66816C2.56079 2.003 4.79959 0 7.45522 0L5.88984 12.8956H6.20869C6.4723 12.8956 6.68459 12.8547 6.84711 12.7729C7.00887 12.6911 7.17138 12.5425 7.33315 12.327L9.61705 9.16251C10.5533 7.86572 12.0417 7.09502 13.6289 7.08637L16.3001 7.07065L11.8924 12.7423C11.6895 13.0089 11.4671 13.2448 11.2236 13.4493C10.9802 13.6545 10.7267 13.8338 10.4639 13.9872C10.677 14.1617 10.8613 14.3639 11.0184 14.5943C11.1754 14.8247 11.3146 15.0889 11.436 15.3862L14.597 23.0097H13.2992V23.0089Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoK);
export default __webpack_public_path__ + "static/media/logo-k.0987faecc7a2f988d978d07169fbb001.svg";
export { ForwardRef as ReactComponent };